module.exports = __webpack_public_path__ + "img/Soccer_ball_animated.2049f604.svg";